import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { RedirectSitePortalToHomeIfPublicNavigationGuard } from '../../guards'
import { LoggedInGuard } from '../../guards/logged-in-guard/logged-in.guard'
import { ResetAttributesService } from '../../services/reset-attributes.service'
import { PasswordResetParams } from './password-reset.params'
import { ResetSentPage } from './reset-sent.page'
import { ResetPage } from './reset.page'

@NgModule({
  providers: [ResetAttributesService],
  imports: [
    ResetPage,
    ResetSentPage,
    RouterModule.forChild([
      {
        path: 'reset',
        component: ResetPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        canActivate: [LoggedInGuard],
        data: {
          title: 'Reset Your Password',
          hideSideNav: true,
        },
      },
      {
        path: 'reset-sent',
        component: ResetSentPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        canActivate: [LoggedInGuard],
        data: {
          title: 'Request Email Sent',
          hideSideNav: true,
        },
      },
      // Lazy load the verify route page in its own module.
      // Keeps password verification library out of the main bundle.
      {
        path: `resetverify/:${PasswordResetParams.Username}`,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () => import('./password-reset-verify-page.module').then(m => m.PasswordResetVerifyPageModule),
      },
    ]),
  ],
  exports: [RouterModule],
})
export class PasswordResetPagesModule {}
